module.exports = __webpack_public_path__ + "img/img01.1cfd29dc.png";